import type { MergeAssetsPublicBodyDto } from '@terra/shared-contracts-applications';
import {
  composeWebpageMergeUrl,
  getWebpageOrigin,
  type AssetMergeCandidate,
  type AssetMergeChoice,
} from './asset-merge-selection';

export function buildMergeAssetsPayload({
  assets,
  choice,
}: {
  assets: readonly AssetMergeCandidate[];
  choice: AssetMergeChoice;
}): MergeAssetsPublicBodyDto {
  const assetType = assets[0]?.assetType === 'webpage' ? 'WEBPAGE' : 'ENDPOINT';

  if (choice.kind === 'EXISTING') {
    return {
      assetType,
      survivor: { kind: 'EXISTING', id: choice.id },
      loserIds: assets
        .filter((asset) => asset.id !== choice.id)
        .map((asset) => asset.id),
      source: 'MANUAL',
    };
  }

  return {
    assetType,
    survivor:
      assetType === 'WEBPAGE'
        ? {
            kind: 'NEW',
            url: composeWebpageMergeUrl({
              origin: getSharedWebpageOrigin(assets),
              path: choice.path,
            }),
          }
        : { kind: 'NEW', path: choice.path },
    loserIds: assets.map((asset) => asset.id),
    source: 'MANUAL',
  };
}

function getSharedWebpageOrigin(
  assets: readonly AssetMergeCandidate[],
): string {
  const webpage = assets.find((asset) => asset.assetType === 'webpage');

  if (webpage?.assetType !== 'webpage') {
    return '';
  }

  return getWebpageOrigin(webpage.url) ?? '';
}
